import Title from "../../shared/ui/Title/Title";
import cls from "./OurServices.module.css";
import MarginBottomContainer from "../../shared/ui/MarginBottomContainer/MarginBottomContainer";

const OurServices = () => {
    const services = [
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="84" height="84" fill="none">
                    <rect width="84" height="84" fill="#fff" rx="42"></rect>
                    <g clipPath="url(#Phone_svg__a)">
                        <path fill="#FF6408" d="M50 26H34a3 3 0 0 0-3 3v26a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V29a3 3 0 0 0-3-3m-8 29c-1.11 0-2-.89-2-2s.89-2 2-2 2 .89 2 2-.888 2-2 2"></path>
                    </g>
                    <defs>
                        <clipPath id="Phone_svg__a">
                            <path fill="#fff" d="M30 26h24v32H30z"></path>
                        </clipPath>
                    </defs>
                </svg>
            ),
            title: "Campaign Management (Google / Facebook / TikTok / Native Ads)",
            description: "We specialize in launching and optimizing high-converting campaigns across all major advertising networks."
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="85" height="84" fill="none">
                    <rect width="84" height="84" x="0.177" fill="#fff" rx="42"></rect>
                    <path fill="#FF6408" d="M54.904 39.09h-.736a11.93 11.93 0 0 0-7.854-10.908h6.096a1.454 1.454 0 1 0 0-.727h-8.778v-.728a.364.364 0 0 0-.364-.363h-2.182a.364.364 0 0 0-.364.363v.727h-8.779a1.455 1.455 0 1 0 0 .728h6.097a11.93 11.93 0 0 0-7.855 10.909h-.735a.364.364 0 0 0-.364.364v2.181a.364.364 0 0 0 .364.364h2.182a.364.364 0 0 0 .363-.364v-2.181a.364.364 0 0 0-.364-.364h-.718a11.206 11.206 0 0 1 9.81-10.814v.632a.364.364 0 0 0 .363.364h2.182a.364.364 0 0 0 .364-.364v-.631a11.205 11.205 0 0 1 9.81 10.813h-.72a.363.363 0 0 0-.363.364v2.181a.364.364 0 0 0 .363.364h2.182a.364.364 0 0 0 .364-.364v-2.181a.364.364 0 0 0-.364-.364"></path>
                    <path fill="#FF6408" d="M43.23 30.928a.363.363 0 0 0-.69.163v11.785a.36.36 0 0 0 .217.333 1.455 1.455 0 1 1-1.16 0 .36.36 0 0 0 .216-.333V31.091a.364.364 0 0 0-.689-.163l-6.909 13.818a.36.36 0 0 0 0 .326l2.646 5.292h10.632l2.645-5.292a.36.36 0 0 0 0-.326zM48.359 51.09H35.995c-.2 0-.364.164-.364.364v2.182c0 .201.163.364.364.364h12.364c.2 0 .363-.163.363-.364v-2.181c0-.201-.163-.364-.363-.364M36.722 57.273a.363.363 0 0 0 .364.363h10.182a.364.364 0 0 0 .363-.363v-2.546H36.722z"></path>
                </svg>
            ),
            title: "CPA / CPS / CPL Advertising",
            description: "Pay only for what matters — whether it's leads, sales, or specific actions."
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="84" height="84" fill="none">
                    <rect width="84" height="84" fill="#fff" rx="42"></rect>
                    <g clipPath="url(#API_svg__a)">
                        <path fill="#FF6408" d="M44.374 36.933 42.24 47.6c-.12.64-.68 1.067-1.306 1.067-.08 0-.174 0-.267-.027a1.33 1.33 0 0 1-1.04-1.573L41.76 36.4a1.33 1.33 0 0 1 1.574-1.04 1.33 1.33 0 0 1 1.04 1.573m-6.094 1.64c-.52-.52-1.36-.52-1.88 0l-1.613 1.614a2.64 2.64 0 0 0 0 3.746l1.613 1.614c.267.266.6.386.947.386.346 0 .68-.133.947-.386.52-.52.52-1.36 0-1.88L36.68 42.08l1.614-1.613c.52-.52.52-1.36 0-1.88zm10.947 1.614-1.613-1.614c-.52-.52-1.36-.52-1.88 0s-.52 1.36 0 1.88l1.613 1.6-1.614 1.614a1.328 1.328 0 0 0 .947 2.266c.347 0 .68-.133.947-.386l1.613-1.614a2.64 2.64 0 0 0 0-3.746zm6.6 9.866a2 2 0 0 1-2.733.734l-.707-.414A13.32 13.32 0 0 1 44 55.2v.813c0 1.107-.893 2-2 2s-2-.893-2-2V55.2a13.32 13.32 0 0 1-8.387-4.827l-.706.414a2.002 2.002 0 0 1-2.733-.733 2 2 0 0 1 .72-2.734l.706-.413A13.3 13.3 0 0 1 28.667 42c0-1.733.333-3.387.933-4.907l-.707-.413a1.99 1.99 0 0 1-.72-2.733 1.99 1.99 0 0 1 2.734-.72l.706.413A13.32 13.32 0 0 1 40 28.813V28c0-1.107.894-2 2-2 1.107 0 2 .893 2 2v.813a13.32 13.32 0 0 1 8.387 4.827l.706-.413a2 2 0 0 1 2.734.72 2 2 0 0 1-.72 2.733l-.707.413c.6 1.52.934 3.174.934 4.907a13.3 13.3 0 0 1-.934 4.907l.707.413a1.99 1.99 0 0 1 .72 2.733M51.334 42c0-5.147-4.187-9.333-9.334-9.333S32.667 36.853 32.667 42s4.186 9.333 9.333 9.333 9.334-4.186 9.334-9.333"></path>
                    </g>
                    <defs>
                        <clipPath id="API_svg__a">
                            <path fill="#fff" d="M26 26h32v32H26z"></path>
                        </clipPath>
                    </defs>
                </svg>
            ),
            title: "Landing Page Design & Optimization",
            description: "We craft fast, responsive, and performance-driven landing pages designed for maximum conversions."
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="85" height="84" fill="none">
                    <rect width="84" height="84" x="0.177" fill="#fff" rx="42"></rect>
                    <path fill="#FF6408" d="m56.713 31.429-3.209-3.208a.76.76 0 0 0-1.07 0l-3.209 3.208a.758.758 0 0 0 1.07 1.07l1.917-1.916v11.795a.757.757 0 0 0 1.514 0V30.582l1.916 1.917a.757.757 0 1 0 1.07-1.07M49.048 35.57l-3.24 1.213a9.4 9.4 0 0 0-4.06-2.34l-.57-3.417h-3.926l-.57 3.417a9.4 9.4 0 0 0-4.058 2.34l-3.241-1.214-1.964 3.4 2.677 2.204a9.13 9.13 0 0 0 0 4.68l-2.677 2.203 1.964 3.401 3.24-1.214a9.4 9.4 0 0 0 4.06 2.34L37.251 56h3.927l.57-3.417a9.4 9.4 0 0 0 4.058-2.34l3.24 1.214 1.964-3.4-2.676-2.204a9.14 9.14 0 0 0 0-4.68l2.676-2.203zm-6.372 8.35-2.648 5.297a.91.91 0 1 1-1.625-.812l1.992-3.984h-3.829a.908.908 0 0 1-.812-1.314l2.65-5.298a.908.908 0 0 1 1.624.813l-1.992 3.983h3.828a.91.91 0 0 1 .812 1.314"></path>
                </svg>
            ),
            title: "Lead Processing & API Integration",
            description: "Our solutions include real-time lead delivery, tracking, and reporting systems, ensuring full transparency at all stages."
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="85" height="84" fill="none">
                    <rect width="84" height="84" x="0.265" fill="#fff" rx="42"></rect>
                    <g fill="#FF6408" clipPath="url(#VR_svg__a)">
                        <path d="M42.266 28.496c3.714 0 7.052 1.282 9.3 3.588 1.85.24 3.594.996 5.036 2.18C54.08 28.964 48.856 26 42.266 26c-6.5 0-11.76 2.96-14.312 8.244a9.96 9.96 0 0 1 4.578-2.094c2.206-2.406 5.682-3.654 9.734-3.654"></path>
                        <path d="M50.266 50a7.98 7.98 0 0 1-5.572-2.26l-.004-.004a3.2 3.2 0 0 0-.552-.334A4.3 4.3 0 0 0 42.266 47c-.828 0-1.458.206-1.87.402a3.2 3.2 0 0 0-.554.334l-.004.004A8 8 0 1 1 34.266 34h16a8 8 0 0 1 0 16"></path>
                    </g>
                    <defs>
                        <clipPath id="VR_svg__a">
                            <path fill="#fff" d="M26.265 26h32v32h-32z"></path>
                        </clipPath>
                    </defs>
                </svg>
            ),
            title: "Analytics & Conversion Tracking Setup",
            description: "From Meta Pixel to Google Analytics and postback integrations — we build reliable data you can count on."
        }
    ];

    return (
        <div id="ourservices" className="services-section">
            <div className="container container--main">
                <div className={cls.servicesWrapper}>
                    <div className="services-wrapper__header">
                        <MarginBottomContainer margin={22}>
                            <Title title="Our Services" />
                        </MarginBottomContainer>
                    </div>

                    {/* Мозаика услуг */}
                    <MarginBottomContainer margin={90}>
                        <div className={cls.servicesGrid}>
                            {services.map((service, index) => (
                                <div key={index} className={cls.serviceCard}>
                                    <div className={cls.serviceIcon}>
                                        {service.icon}
                                    </div>
                                    <h3 className={cls.serviceTitle}>
                                        {service.title}
                                    </h3>
                                    <p className={cls.serviceDescription}>
                                        {service.description}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </MarginBottomContainer>

                </div>
            </div>
        </div>
    );
};

export default OurServices;